<template>
<div v-bind:class="{ 'pc-header':pcHeaderStyle,'mob-header':mobHeaderStyle,'ipad-header':ipadHeaderStyle }">
  <div class="header__container" v-bind:class="[theme, {'open-menu-fixed': openMenuFixed}]">
    <router-link v-on:click.native="mbNavOff()"  to="/">
      <div class="header__logo__area">
        <img class="header__logo header__logo-pc" v-bind:class="{ipad:ipad}" v-bind:src="headerContents.logo">
        <img class="header__logo header__logo-sp" v-bind:class="{ipad:ipad}"  v-bind:src="headerContents.logoSp">
      </div>
    </router-link>
    <div id="mb_nav_trigger" v-on:click="mbNavOn">
      <div class="mb_nav_position">
        <span class="mb_nav_hamburger" v-bind:class="{ mb_nav_hamburger_active:mbHamburgerActive }"></span>
        <span class="mb_nav_hamburger" v-bind:class="{ mb_nav_hamburger_active:mbHamburgerActive }"></span>
        <span class="mb_nav_hamburger" v-bind:class="{ mb_nav_hamburger_active:mbHamburgerActive }"></span>
      </div>
    </div>

    <div class="header__nav__container" v-bind:class="{ mb_nav_action:mbNavAction }">
      <div class="nav-scroll-area">
      <ul  v-bind:class="{ipad:ipad}"  class="header__nav__list">
        <li class="header__nav__works__block">
          <router-link v-on:click.native="mbNavOff()" class="header__nav__animation__works works__link__Invalidation"  v-bind:to ="{ name:'works',params:{ tag:'All',url:'All' }}">
            <img class="header__nav__main" v-bind:src="headerContents.NavWorks">
          </router-link>
          <div class="works__link__list">
            <ul>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'All',url:'All' }}">
                  <img class="header__works__tag" v-bind:src="headerContents.NavWorksAll">
                </router-link>
              </li>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Theater',url:'Theater' }}">
                  <img class="header__works__tag" v-bind:src="headerContents.NavWorksTheater">
                </router-link>
              </li>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Exhibition',url:'Exhibition'}}">
                  <img class="header__works__tag__exhibition" v-bind:src="headerContents.NavWorksExhibition">
                </router-link>
              </li>
              <li class="header__works__tag_content header__works-tag-projection-work">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Projection Work',url:'Projection Work'}}">
                  <img class="header__works__tag__high" v-bind:src="headerContents.NavWorksProjectionWork">
                </router-link>
              </li>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Art Project',url:'Art Project'}}">
                  <img class="header__works__tag__high" v-bind:src="headerContents.NavWorksArtProject">
                </router-link>
              </li>
              <li class="header__works__tag_content header__works-tag-technical-work">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Technical Work',url:'Technical Work'}}">
                  <img class="header__works__tag__technical__work" v-bind:src="headerContents.NavWorksTechnicalWork">
                </router-link>
              </li>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Workshop',url:'Workshop' }}">
                  <img class="header__works__tag__high" v-bind:src="headerContents.NavWorksWorkshop">
                </router-link>
              </li>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'works',params:{ tag:'Toyohashi',url:'Toyohashi'}}">
                  <img class="header__works__tag__toyohashi" v-bind:src="headerContents.NavWorksToyohashi">
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- About -->
         <li class="header__nav__works__block">
          <span v-on:click.native="mbNavOff()" class="header__nav__animation__works works__link__Invalidation">
            <img class="header__nav__main" v-bind:src="headerContents.NavAbout">
          </span>
          <div class="works__link__list">
            <ul>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'profile'}">
                  <img class="header__works__tag" v-bind:src="headerContents.NavYamadashimpei">
                </router-link>
              </li>
              <li class="header__works__tag_content">
                <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation" v-bind:to ="{ name:'aozora'}">
                  <img class="header__works__tag__aozora" v-bind:src="headerContents.NavAozora">
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation header__contact-hover"  v-bind:to ="{ name:'hiyamizu'}">
            <img class="header__nav__main" v-bind:src="headerContents.NavHiyamizu">
          </router-link>
        </li>
        <li id="mob-link-last">
          <router-link v-on:click.native="mbNavOff()"  class="header__nav__animation header__contact-hover"  v-bind:to ="{ name:'contact'}">
            <img class="header__nav__main" v-bind:src="headerContents.NavContact">
          </router-link>
        </li>
      </ul>

      </div>

    </div>
  </div>
</div>
</template>
<script>
import {getHeaderContents} from '../../util/header.js';
export default {
  name: 'Header',
  // 親から受け取るデータ
  props: {
    theme: String
  },
  data() {
    return {
      // モバイルナビ false: 閉じている状態
      mbNavFlag: false,
      mbNavAction: true,
      // ハンバーガーメニューアニメーション false:≡ true: ×
      mbHamburgerActive: false,
      // PC用のスタイル
      pcHeaderStyle: true,
      mobHeaderStyle: false,
      ipadHeaderStyle: false,
      openMenuFixed: false,
    }
  },
  computed: {
    headerContents: function() {
      const headerContents = getHeaderContents(this.theme);
      return {
        logo: headerContents.logo,
        logoSp: headerContents.logoSp,


        NavAbout: headerContents.srcNavAbout,
        NavYamadashimpei:headerContents.srcNavYamadashimpei,
        NavAozora:headerContents.srcNavAozora,

        NavHiyamizu: headerContents.srcNavHiyamizu,
        NavContact: headerContents.srcNavContact,

        NavWorks: headerContents.srcNavWorks,
        NavWorksAll: headerContents.srcNavWorksAll,
        NavWorksTheater: headerContents.srcNavWorksTheater,
        NavWorksExhibition: headerContents.srcNavWorksExhibition,
        NavWorksToyohashi: headerContents.srcNavWorksToyohashi,
        NavWorksProjectionWork: headerContents.srcNavWorksProjectionWork,
        NavWorksArtProject: headerContents.srcNavWorksArtProject,
        NavWorksWorkshop: headerContents.srcNavWorksWorkshop,
        NavWorksTechnicalWork: headerContents.srcNavWorksTechnicalWork
      }
    }
  },
  created() {
    // モバイル用のヘッダースタイル適応
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('Android') > 0) {
        this.pcHeaderStyle = false;
        this.mobHeaderStyle = true;
        this.ipadHeaderStyle = false;

        // safariのブラウザバックバー高さ対策
        this.setFillHeight();
    }
    // ipad用のヘッダースタイル適応
    if (navigator.userAgent.indexOf('iPad') > 0 ) {
        this.pcHeaderStyle = false;
        this.mobHeaderStyle = false;
        this.ipadHeaderStyle = true;

        // safariのブラウザバックバー高さ対策
        this.setFillHeight();
    }
  },
  mounted: function() {
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('iPad') > 0 ||
      navigator.userAgent.indexOf('Android') > 0) {
    window.addEventListener('resize', this.setFillHeight)
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.setFillHeight)
  },
  methods: {
    mbNavOn:function() {
      if (!this.mbNavFlag) {
        this.mbNavAction = false;
        this.mbHamburgerActive = true;
        this.mbNavFlag = true;
        this.openMenuFixed = true;
      } else {
        this.mbNavAction = true;
        this.mbHamburgerActive = false;
        this.mbNavFlag = false;
        this.openMenuFixed = false;
      }
    },
    mbNavOff:function() {
      this.mbNavAction = true;
      this.mbHamburgerActive = false;
      this.mbNavFlag = false;
      this.openMenuFixed = false;
    },
    // safariのブラウザバックバー高さ対策
    setFillHeight:function() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }
}
</script>
<style lang="scss" scoped>
.header__container {
  position: relative;
  height: 16vh;
  width: 100vw;
  z-index: 100;
}
.header__container.default {
  position: fixed;
  background: #000000;
} 
.header__logo__area {
  position: absolute;
  display: grid;
  top: 50%;
  left: 16%;
  transform: translate(-16%,-50%);
  .header__logo {
    // ロゴの大きさ
    height: 15.5vw;
    max-height: 12vh;
  }
}
#mb_nav_trigger {
  position: absolute;
  cursor: pointer;
  height: 5vw;
  width: 5vw;
  top: 24%;
  right: 8%;
  transform: translate(8%,-24%);
  
}
.mb_nav_position {
  position: relative;
}
// ハンバーガーメニュー
.mb_nav_hamburger {
  position: absolute;
  transition: all .2s;
  display: inline-block;
  width: 100%;
  height: 2px;
  background: #ffffff;
  box-sizing: border-box;
}
.white {
  .header__nav__container {
    background: #ffffff;
  }
  .mb_nav_hamburger {
    background: #000000;
  }
}

.mb_nav_hamburger:nth-of-type(1) {
  top: 0.5vw;
}
.mb_nav_hamburger:nth-of-type(2) {
  top: 2.5vw;
}
.mb_nav_hamburger:nth-of-type(3) {
  top: 4.5vw;
}
// ハンバーガーメニューON
.mb_nav_hamburger.mb_nav_hamburger_active:nth-of-type(1) {
  transform: translateY(2vw) rotate(-45deg);
}
.mb_nav_hamburger.mb_nav_hamburger_active:nth-of-type(2) {
  opacity: 0;
}
.mb_nav_hamburger.mb_nav_hamburger_active:nth-of-type(3) {
  transform: translateY(-2vw) rotate(45deg);
}
.header__nav__main {
  height: 25px;
}
.header__works__tag__high {
  height: 4.5vw;
}
.header__works__tag {
  height: 3.6vw;
}
.header__works__tag__exhibition {
  height: 3.4vw;
}
.header__works__tag__technical__work {
  height: 3.6vw;
}
.header__works__tag__toyohashi {
  height: 4vw;
}
.header__works__tag__aozora {
  height: 4.1vw;
}
ul {
    line-height: normal;
    list-style: none;
    }
.works__link__list {
    li {
      padding-top: 2.2vw;
      padding-bottom: 1vw;
    }
    .header__works-tag-projection-work {
      padding-top: 2.5vw;
    }
    .header__works-tag-technical-work {
      padding-top: 1vw;
    }
}
.mb_nav_action {
  display: none
}
// PC
@media screen and (max-width: 767px) {  
  .open-menu-fixed {
    position: fixed;
    top: 0;
  }
  .nav-scroll-area{
    width: 100%;
    overflow: scroll;
  }
  .header__nav__container {
    width: 100vw;
    height: 100vh;
    background: #000000;
    padding-top: 16vh;
    padding-left: 5.3vw;
  }
  .header__nav__list {
    padding-top: 0;
  }

  .header__nav__main {
    margin-top: 5.5vw;
  }
  .works__link__list {
    margin-left: 4vw;
  }
}

// モバイルのみ
.mob-header {
    .header__nav__container {
      width: 100vw;
      min-height: 100vh;
      min-height: calc(var(--vh, 1vh) * 100);
      padding-top: 16vh;
      padding-left: 5.3vw;
      position: fixed;
      z-index: -1;
  }
  .nav-scroll-area{
    width: 100%;
    height: calc((var(--vh, 1vh) * 100 ) - 16vh);
    overflow: scroll;
  }
  .header__nav__list {
    padding-top: 20px;
  }
  .open-menu-fixed {
    position: fixed;
    top: 0;
  }
  .header__nav__main {
    margin-top: 24px;
    height: 20px;
  }
  .works__link__list {
    margin-left: 4vw;
  }
  .header__works__tag {
    height: 18px;
  }
  .header__works__tag__high {
    height: 21px;
  }
  .header__works__tag__exhibition {
    height: 16px;
  }
  .header__works__tag__technical__work {
    height: 17px;
  }
  .header__works__tag__toyohashi {
    height: 20px;
  }
  .header__works__tag__aozora {
    height: 21px;
  }
  .works__link__list li {
    padding-top: 10px;
    padding-bottom: 0px;
  }
  #mob-link-last {
    margin-bottom: 5vh;
  }
}
.header__logo-pc {
  display: none;
}

@media screen and (min-width: 768px) {
  .header__logo-sp {
    display: none;
  }
  .header__logo-pc {
  display: block;
  }
  .pc-header {
    // ハンバーガーメニュー
    .mb_nav_hamburger {
      display: none;
    }  
    .header__container {
      height: 3.5vw;
      max-height: 55px;
      min-height: 45px;
    }
    .header__logo__area {
      left: 2.8%;
      transform: translate(-2.8%,-50%);
      .header__logo {
        // ロゴの大きさ
        height: 1.4vw;
        max-height: 22px;
        min-height: 14px;
      }
    }
    .header__nav__container {
      position: absolute;
      right: 2.8%;
      width: 34%;
      max-width: 550px;
      min-width: 300px;
      top: 50%;
      transform: translateY(-50%);
      display: block;
      .header__nav__list {
        display: flex;
        justify-content: space-between;
        list-style: none;
      }
    }
    .header__nav__main {
      height: 1.28vw;
      max-height: 20px;
      min-height: 14px;
    }
    .header__works__tag__high {
      height: 1.3vw;
      max-height: 18px;
      min-height: 14px;
    }
    .header__works__tag__toyohashi {
      height: 1.2vw;
      max-height: 17px;
      min-height: 13px;
    }
    .header__works__tag__exhibition {
      height: 0.85vw;
      max-height: 15px;
      min-height: 12px;
    }
    .header__works__tag__technical__work {
      height: 1.05vw;
      max-height: 15px;
      min-height: 12px;
    }
    .header__works__tag {
      height: 1.0vw;
      max-height: 16px;
      min-height: 12px;
    }
    .header__works__tag__aozora {
      height: 1.3vw;
      max-height: 18px;
      min-height: 14px;
    }
    .works__link__list {
        li {
          padding-top: 3.5px;
          padding-bottom: 3.5px;
        }
        .header__works-tag-projection-work {
          padding-top: 5px;
        }
        .header__works-tag-technical-work {
          padding-top: 1px;
        }
    }
    .header__nav__works__block:hover .works__link__list { 
      display: block;
      animation-name: appearanceNav;
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }
    .header__nav__works__block .works__link__list {
      position: absolute;
      padding: 0 13px 10px 13px;
      opacity: 0;
      display: none;
    }
    @keyframes appearanceNav {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .header__nav__works__block:hover {
      .header__nav__animation__works {
      border-bottom: solid 1px #ffffff;
      }
    }
    .works__link__list {
      background-color: #000000;
      .header__nav__animation:hover {
        border-bottom: solid 1px #ffffff;
      }
    }
    .header__profile-hover:hover,.header__contact-hover:hover {
      border-bottom: solid 1px #ffffff;
    }
    .white {
      .works__link__list {
        background-color: #ffffff;
      }
      .header__nav__works__block:hover {
        .header__nav__animation__works {
        border-bottom: solid 1px #000000;
        }
      }
      .works__link__list {
        .header__nav__animation:hover {
          border-bottom: solid 1px #000000;
        }
      }
      .header__profile-hover:hover,.header__contact-hover:hover {
        border-bottom: solid 1px #000000;
      }
    }
  }
}
// ipad
// @media screen and (max-width: 1024px) { 
//   }
// ipadスタイル
.ipad-header {
  .header__logo-sp {
    display: block;
  }
  .header__logo-pc {
    display: none;
  }
  .header__logo {
    height: 13.5vw;
  }
  .header__logo__area {
    left:14%;
  }
  .nav-scroll-area{
    width: 100%;
    height: calc((var(--vh, 1vh) * 100 ) - 16vh);
    overflow: scroll;
  }

  .header__nav__container {
    padding-top: 16vh;
    padding-left: 5.3vw;
    background: #000000;
  }
  .open-menu-fixed {
    position: fixed;
    top: 0;
  }
  .header__nav__list {
    padding-top: 40px;
  }
  .header__nav__main {
    margin-top: 24px;
    height: 24px;
  }
  .works__link__list {
    margin-left: 4vw;
  }
  .header__works__tag {
    height: 22px;
  }
  .header__works__tag__high {
    height: 25px;
  }
  .header__works__tag__aozora {
    height: 23.8px;
  }
  .works__link__list li {
    padding-top: 20px;
    padding-bottom: 0px;
  }
  #mob-link-last {
    margin-bottom: 5vh;
  }

  .white {
    .header__nav__container {
      background: #ffffff;
    }
  }
}
</style>